import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getText } from "../../../../utils/util";
import copy from "copy-to-clipboard";
import { Cell, Dialog } from "react-vant";
import "./index.css";
import { Button } from "antd";
import { Toast } from "antd-mobile";
import { useState } from "react";

export default function CenterPage({ czList }) {
  const navigate = useNavigate();
  const { t: translate } = useTranslation();
  //充值列表
  const getCzNodes = () => {
    const nodes = [];
    for (const cz of czList) {
      const node = (
        <li key={cz.id} className="mb-4">
          <div className="bg-neutral-800 rounded-lg shadow-md overflow-hidden border border-neutral-700 hover:border-primary transition-all duration-200">
            <div className="p-4 flex justify-between items-center">
              <div className="flex flex-col">
                <div className="flex items-center">
                  <span className="text-xl font-semibold text-white">
                    {cz.num}
                  </span>
                  <span className="ml-2 text-primary font-medium">
                    {cz.coin.toUpperCase()}
                  </span>
                </div>
                <div className="text-neutral-400 text-sm mt-1">
                  {cz.addtime}
                </div>
              </div>
              <div>
                <span className={`px-3 py-1 rounded-full text-sm font-medium ${
                  cz.status === 1 
                    ? 'bg-warning/20 text-warning' 
                    : cz.status === 2 
                    ? 'bg-success/20 text-success' 
                    : 'bg-danger/20 text-danger'
                }`}>
                  {translate(
                    getText(
                      cz.status === 1
                        ? "待審查"
                        : cz.status === 2
                        ? "已完成"
                        : "失敗"
                    )
                  )}
                </span>
              </div>
            </div>
          </div>
        </li>
      );
      nodes.push(node);
    }
    return nodes;
  };
  
  return (
    <div className="w-full max-w-5xl mx-auto px-4 py-6">
      <div className="bg-neutral-900">
        {czList && czList.length > 0 ? (
          <ul className="list-none p-0"> 
            {getCzNodes()}
          </ul>
        ) : (
          <div className="flex flex-col items-center justify-center py-16 text-neutral-400">
            <svg xmlns="http://www.w3.org/2000/svg" className="h-16 w-16 mb-4 text-neutral-700" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M19 11H5m14 0a2 2 0 012 2v6a2 2 0 01-2 2H5a2 2 0 01-2-2v-6a2 2 0 012-2m14 0V9a2 2 0 00-2-2M5 11V9a2 2 0 012-2m0 0V5a2 2 0 012-2h6a2 2 0 012 2v2M7 7h10" />
            </svg>
            <p className="text-lg">{translate(getText("暂无数据"))}</p>
          </div>
        )}
      </div>
    </div>
  );
}
